import type { RouteRecordRaw } from 'vue-router';

export const groupsRoute: RouteRecordRaw = {
  path: '/groups',
  name: 'Groups',
  component: () => import('./pages/GroupsPage.vue'),
  meta: {
    layout: 'main',
    // `:get`, а не `:list` — див. коментар біля пункту меню «Групи» в
    // MainLayout.vue: `groups:list` роздано ще й заради фільтра студентів.
    authorize: ({ isGranted }) => isGranted('ugi:core:groups:get'),
  },
};

export const groupDetailRoute: RouteRecordRaw = {
  path: '/groups/:id',
  name: 'GroupDetail',
  component: () => import('./pages/GroupPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('ugi:core:groups:get'),
  },
};
